import { NgModule } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';

import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { NewTripPlannerRoutingModule } from './new-trip-planner-routing.module';

import { CarRentalService } from '../car-rental/services/car-rental.service';
import { CountryInfoService } from '../../core/services/country-info.service';
import { OccasionGeniusService } from '../../core/services/occasion-genius.service';

import { NewTripPlannerViewComponent } from './new-trip-planner.component';
import { PlacesListComponent } from '../country-info/components/places-list/places-list.component';
import { TripPlannerWelcomeComponent } from './trip-planner-welcome/trip-planner-welcome.component';
import { OccasionGeniusComponent } from '../../shared/components/occasion-genius/occasion-genius.component';
import { TravellersTransformerPipe } from '../../shared/components/trip-wizard/travellers-transformer.pipe';
import { TripPlannerInteractionComponent } from './trip-planner-interaction/trip-planner-interaction.component';
import { CarRentalPreviewComponent } from '../car-rental/components/car-rental-preview/car-rental-preview.component';
import { TripCardListComponent } from './trip-planner-interaction/components/trip-card-list/trip-card-list.component';
import { SearchInputFieldComponent } from '../../shared/components/forms/search-input-field/search-input-field.component';
import { MobileTripPlannerInteractionComponent } from './mobile-trip-planner-interaction/mobile-trip-planner-interaction.component';

@NgModule({
  imports: [
    NewTripPlannerRoutingModule,
    TripCardListComponent,
    OccasionGeniusComponent,
    SearchInputFieldComponent,
    PlacesListComponent,
    NgOptimizedImage,
    MatSlideToggleModule,
    TripPlannerWelcomeComponent,
    TripPlannerInteractionComponent,
    CarRentalPreviewComponent,
    MobileTripPlannerInteractionComponent,
  ],
  declarations: [NewTripPlannerViewComponent],
  providers: [
    CarRentalService,
    CountryInfoService,
    OccasionGeniusService,
    TravellersTransformerPipe,
  ],
})
export class NewTripPlannerModule {}
